/**
 * PLUGINS.md §3 experts — is a newer version of the expert a network was created from shipped by its plugin?
 * A network created from a plugin carries ``sourceRegistryId = plugin:<pluginId>:<expertId>`` and
 * ``sourceRegistryVersion`` = the plugin version as an int (``1.2.3`` → 100020003 — the platform's own encoding, collision-free for parts ≤ 9999); the catalog (``GET /tools/plugins``)
 * has the installed plugin's version. PURE.
 */

export function pluginSourceOf(network) {
  const sp = network?.sourcePlugin;                 // TYPED provenance first; the string anchor for older rows
  if (sp && sp.pluginId && sp.expertId) return { pluginId: String(sp.pluginId), expertId: String(sp.expertId) };
  const parts = String(network?.sourceRegistryId || '').split(':');
  return parts.length === 3 && parts[0] === 'plugin' && parts[1] && parts[2] ? { pluginId: parts[1], expertId: parts[2] } : null;
}

export function versionInt(v) {
  const [a = 0, b = 0, c = 0] = String(v || '').split('.').map((x) => parseInt(x, 10) || 0);
  const cap = (x) => Math.min(x, 9999);
  return cap(a) * 100000000 + cap(b) * 10000 + cap(c);
}

/** → ``null`` (not from a plugin) | ``{available, latestLabel, deployedLabel, installed}``. */
export function pluginExpertUpgrade(network, plugins) {
  const src = pluginSourceOf(network);
  if (!src) return null;
  const p = (plugins || []).find((x) => x.id === src.pluginId);
  const installed = !!p && !(p.install && p.install.installed === false);
  const ships = !!p && (p.experts || []).some((x) => x.id === src.expertId);
  const latest = versionInt(p?.version);
  return {
    available: installed && ships && latest > (Number(network?.sourceRegistryVersion) || 0),
    latestLabel: p?.version || '', deployedLabel: network?.sourcePluginVersion || '', installed,
    pluginName: p?.displayName || src.pluginId,
  };
}
